//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The template custom var model
* 
* @param `value` The custom value
* @param variable The custom variable
*/
@Serializable

data class CustomVariable (


      /* The custom value */
    @SerialName(value = "value") @Required val `value`: kotlin.String,


      /* The custom variable */
    @SerialName(value = "variable") @Required val variable: kotlin.String


) {




  }

